import { InputFileInformationSelection } from './InputFileInformationSelection';
import { InputFileContainerInputProps } from '../common';
import { InputLabelsMapFetcher } from '@/app/features/products/common/services/InputLabelsMapFetcher';
import { useDataStore } from '@/app/core/components/step-wizard';
import { getCurrentFeatureCode } from '@/app/core/auth';
import { inputFileInformationValidator } from '@ssar-app/domain';
import { useEffect, useState } from 'react';

export const InputFileSelectionContainer = (
  props: InputFileContainerInputProps,
) => {
  const [subCode, setSubCode] = useState<string>('');
  const { keys, inputFileSelectionOptions } = props;
  const { data } = useDataStore();
  useEffect(() => {
    if (data?.subCode !== '') {
      setSubCode(data?.subCode);
    }
  }, [data?.subCode]);
  return (
    <>
      {subCode !== '' && (
        <InputLabelsMapFetcher
          subCode={subCode}
          onSuccess={(inputLabelsMap, isLoading) => {
            return (
              <InputFileInformationSelection
                stepKey={keys}
                moduleProps={{
                  productName: getCurrentFeatureCode() || '',
                  inputFileSelectionOptions: inputFileSelectionOptions,
                  inputLabelsMap: inputLabelsMap,
                  isLoading: isLoading,
                }}
                validator={inputFileInformationValidator}
              />
            );
          }}
          onError={(error) => {
            console.error(error);
          }}
        />
      )}
    </>
  );
};
